import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { QrScannerView } from '@features/qr-scanner';
import { useCheckIn } from '@features/check-in';
import type { CheckInResult } from '@features/check-in';

/**
 * Haupt-Scan-Seite der Scanner PWA.
 * Zeigt den QR-Scanner und leitet nach erfolgreichem Check-in weiter.
 *
 * @returns Scan-Seite mit Kamera und Event-Info
 */
export function ScanPage() {
  const navigate = useNavigate();
  const { mutate: checkIn, isPending } = useCheckIn();
  const [isScanning, setIsScanning] = useState(true);

  const eventId = sessionStorage.getItem('selectedEventId') ?? '';
  const eventTitle = sessionStorage.getItem('selectedEventTitle') ?? 'Unbekanntes Event';

  const handleScan = (barcode: string) => {
    if (isPending) return;
    setIsScanning(false);

    checkIn(
      { eventId, barcode, method: 'qr' },
      {
        onSuccess: (result: CheckInResult) => {
          sessionStorage.setItem('lastCheckInResult', JSON.stringify(result));
          void navigate({ to: '/result' });
        },
        onError: (err) => {
          const message = err instanceof Error ? err.message : 'Unbekannter Fehler';
          sessionStorage.setItem('lastCheckInResult', JSON.stringify({ error: true, message }));
          void navigate({ to: '/result' });
        },
      },
    );
  };

  return (
    <div
      style={{
        minHeight: '100dvh',
        backgroundColor: '#0f0f23',
        color: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px',
          backgroundColor: '#1a1a2e',
          borderBottom: '1px solid #333',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>QR-Code scannen</div>
          <div style={{ color: '#4ade80', fontSize: '13px' }}>{eventTitle}</div>
        </div>
        <button
          onClick={() => void navigate({ to: '/select-event' })}
          style={{
            minHeight: '44px',
            padding: '8px 16px',
            backgroundColor: 'transparent',
            color: '#aaa',
            border: '1px solid #333',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '13px',
          }}
        >
          Event wechseln
        </button>
      </div>

      {/* Scanner */}
      <div
        style={{ flex: 1, padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}
      >
        {isPending ? (
          <div
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: '16px',
              color: '#aaa',
            }}
          >
            <p>Check-in wird verarbeitet...</p>
          </div>
        ) : (
          <QrScannerView onScan={handleScan} isActive={isScanning} />
        )}
      </div>
    </div>
  );
}
